import { viewerModel as baseViewerModel } from '../model';

export const viewerModel = {
	$account: baseViewerModel.$account,
};
